import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect } from "react";

import { Button } from "../../../../../../components/Button/Button";
import { ModalsContext } from "../../../../../../context/modals.context";
import { MinistryContext } from "../../../../../../modules/ministry/ministry.context";
import { ministryService } from "../../../../../../modules/ministry/ministry.service";
import { downloadFile } from "../../../../../../utils/fileDownload";
import { toastService } from "../../../../../../utils/toast.service";
import { Documentation } from "../../../../components/Documentation/Documentation";
import { Info } from "../../../../components/Info/Info";
import { InformationAbout } from "../../../../components/InformationAbout/InformationAbout";
import { LicenceModal } from "./components/LicenceModal/LicenceModal";
import style from "./OverviewWarehoseRequest.module.scss";

export const OverviewWarehoseRequest = () => {
  const { ministry, setMinistry } = useContext(MinistryContext);
  const { handleUpdateModals, setError } = useContext(ModalsContext);

  const createDohvatiDokumentMfin = async () => {
    const [err, res] = await to(
      ministryService.createDohvatiDokumentMfin({
        documentId: ministry.detaljiOSkladistu.dokumentId,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
    downloadFile(
      res.data.data,
      ministry.detaljiOSkladistu?.evidencioniBroj
        ? `${ministry.detaljiOSkladistu?.evidencioniBroj}-resenje`
        : "resenje",
      res.data.format as any
    );
  };

  const postDetaljiOSkladistu = async () => {
    let queryParams = new URLSearchParams(window.location.search);
    const [err, res] = await to(
      ministryService.postDetaljiOSkladistu({
        skladisteId: Number(queryParams.get("id")),
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setMinistry({
      detaljiOSkladistu: res.data,
    });
    handleUpdateModals({ dozvolaZahtevId: res.data.dozvolaZahtevId });
  };

  useEffect(() => {
    postDetaljiOSkladistu();
  }, []);

  return (
    <div className={style.mainContainer}>
      <LicenceModal />
      <InformationAbout
        data={ministry.detaljiOSkladistu.drustvoInfo}
        type={t("AKCIZNE_MARKICE.SKLADISTU")}
      />
      <Info dataSkladista={ministry.detaljiOSkladistu} />
      <Documentation
        data={ministry.detaljiOSkladistu.dozvolaZahteviDostavljeniDokazi}
        kategorijaProizvodaId={
          ministry.detaljiOSkladistu?.kategorijaProizvodaId
        }
      />
      <div className={style.buttonContainer}>
        {!ministry.detaljiOSkladistu?.isReadonly ? (
          <Button
            type="primary"
            onClick={() => {
              if (ministry.detaljiODozvoli?.isReadonly) return;
              handleUpdateModals({ modalVisible: "licence" });
            }}
          >
            {t("COMMON.ODUZMI_DOZVOLU")}
          </Button>
        ) : (
          <></>
        )}
        <Button
          type="primary"
          className="ml-15"
          onClick={() => createDohvatiDokumentMfin()}
        >
          {t("COMMON.PREUZMI_VAZECE_RESENJE")}
        </Button>
      </div>
    </div>
  );
};
